import { PdpInfoDTO, PlanFilter } from '@/types/models';
import { client } from '@/api/client';
import { generateParams } from '@/utils/function';
export async function getPlans(filter: PlanFilter): Promise<PdpInfoDTO[]> {
  try {
    const queryParams = generateParams<PlanFilter>(filter);
    const res = await client.get(`/plans?${queryParams}`);
    return res?.data?.data;
  } catch (error) {
    return [];
  }
}
export const plansOptions = (filter: PlanFilter) => {
  return {
    queryKey: ['plans', filter],
    queryFn: () => getPlans(filter)
  };
};